"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var GetBucketNotificationConfigurationInput_1 = require("./GetBucketNotificationConfigurationInput");
var GetBucketNotificationConfigurationOutput_1 = require("./GetBucketNotificationConfigurationOutput");
var ServiceMetadata_1 = require("./ServiceMetadata");
exports.GetBucketNotificationConfiguration = {
    metadata: ServiceMetadata_1.ServiceMetadata,
    name: "GetBucketNotificationConfiguration",
    http: {
        method: "GET",
        requestUri: "/{Bucket}?notification"
    },
    input: {
        shape: GetBucketNotificationConfigurationInput_1.GetBucketNotificationConfigurationInput
    },
    output: {
        shape: GetBucketNotificationConfigurationOutput_1.GetBucketNotificationConfigurationOutput
    },
    errors: []
};
//# sourceMappingURL=GetBucketNotificationConfiguration.js.map